<mat-horizontal-stepper [linear]="true" #stepper>
  <mat-step orgForm [stepControl]="orgForm">
    <form [formGroup]="orgForm" class="w-full">
      <ng-template matStepLabel> {{ "ORGANIZATIONS" | translate }}</ng-template>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "ORG_NAME" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="org_name" />
            <mat-error *ngIf="orgForm.get('org_name')?.hasError('required')">
              {{ "ORG_NAME_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width" *ngIf="organizationId">
          <mat-label>{{ "companyCode" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="company_code" readonly />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>{{ "org_type_" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <mat-select formControlName="org_type" required>
              <mat-option value="cooperative">Cooperative (Co-op)</mat-option>
              <mat-option value="corporation">Corporation</mat-option>
              <mat-option value="franchise">Franchise</mat-option>
              <mat-option value="government_organization">Government Organization</mat-option>
              <mat-option value="joint_venture">Joint Venture</mat-option>
              <mat-option value="opc">One Person Company (OPC)</mat-option>
              <mat-option value="partnership">Partnership</mat-option>
              <mat-option value="private_limited">Private Limited Company (Pvt Ltd)</mat-option>
              <mat-option value="psu">Public Sector Undertaking (PSU)</mat-option>
              <mat-option value="public_limited">Public Limited Company (Ltd)</mat-option>
              <mat-option value="sole_proprietorship">Sole Proprietorship</mat-option>
              <mat-option value="trust">Trust</mat-option>
            </mat-select>
            <mat-error *ngIf="orgForm.get('org_type')?.hasError('required')">
              {{ "ORG_TYPE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "DOMAIN" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="full-width">
            <mat-select formControlName="domain" [multiple]="true" required>
              <mat-option value="Consultancy">Consultancy</mat-option>
              <mat-option value="Construction">Construction</mat-option>
              <mat-option value="Road">Road</mat-option>
              <mat-option value="Utilities">Utilities</mat-option>
            </mat-select>
            <mat-error *ngIf="orgForm.get('domain')?.hasError('required')">
              {{ "DOMAIN_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="half-width">
          <mat-label>{{ "REG_NO" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="registration_number" />
            <mat-error *ngIf="orgForm.get('registration_number')?.hasError('required')">
              {{ "CIN_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "GST_NO" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="gst_number" />
            <mat-error *ngIf="orgForm.get('gst_number')?.hasError('required')">
              {{ "GST_REQUIRED" | translate }}
            </mat-error>
            <mat-error *ngIf="orgForm.get('gst_number')?.hasError('pattern')">
              {{ "GST_PATTERN_INVALID" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>{{ "PAN" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="pan_number" />
            <mat-error *ngIf="orgForm.get('pan_number')?.hasError('required')">
              {{ "PAN_REQUIRED" | translate }}
            </mat-error>
            <mat-error *ngIf="orgForm.get('pan_number')?.hasError('pattern')">
              {{ "PAN_PATTERN_INVALID" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label> {{ "line1" | translate }}</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="address_line_1" />
            <mat-error *ngIf="orgForm.get('address_line_1')?.hasError('required')">
              {{ "employee.address" | translate }} {{ "REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label> {{ "line2" | translate }}</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="address_line_2" />
            <mat-error *ngIf="orgForm.get('address_line_2')?.hasError('required')">
              {{ "employee.address" | translate }} {{ "REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "COUNTRY" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <mat-select formControlName="country" (selectionChange)="onCountryChange()" required>
              <mat-option value="">{{
                "SELECT_COUNTRY" | translate
                }}</mat-option>
              <mat-option value="India">India</mat-option>
            </mat-select>
            <mat-error *ngIf="orgForm.get('country')?.hasError('required')">
              {{ "COUNTRY_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>{{ "STATE" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <mat-select formControlName="state" (selectionChange)="onStateChange()" required>
              <mat-option value="">{{ "SELECT_STATE" | translate }}</mat-option>

              <mat-option *ngFor="let state of states" [value]="state">{{
                state
                }}</mat-option>
            </mat-select>
            <mat-error *ngIf="orgForm.get('state')?.hasError('required')">
              {{ "STATE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "DISTRICT" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <mat-select formControlName="district" (selectionChange)="onDistrictChange()" required>
              <mat-option value="">{{ "SELECT_DISTRICT" | translate }}</mat-option>
              <mat-option *ngFor="let d of districts" [value]="d">{{ d }}</mat-option>
            </mat-select>
            <mat-error *ngIf="orgForm.get('district')?.hasError('required')">
              {{ "DISTRICT_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>{{ "CITY" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <mat-select formControlName="city" required>
              <mat-option value="">{{ "SELECT_CITY" | translate }}</mat-option>
              <mat-option *ngFor="let city of cities" [value]="city">{{
                city
                }}</mat-option>
            </mat-select>
            <mat-error *ngIf="orgForm.get('city')?.hasError('required')">
              {{ "CITY_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "POSTAL_CODE" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="postal_code" />
            <mat-error *ngIf="orgForm.get('postal_code')?.hasError('required')">
              {{ "PINCODE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-checkbox formControlName="additional_branch">Add branch</mat-checkbox>
        </div>
      </div>
      <div class="flex items-center gap-6 flex-wrap" style="margin-bottom: 5px">
        <div class="flex flex-col gap-2">
          <mat-label> {{ "UPLOAD_LOGO" | translate }}</mat-label>
          <button mat-raised-button color="primary" (click)="fileInput.click()">
            {{ "UPLOAD_LOGO" | translate }}
          </button>
          <input type="file" accept="image/*" hidden #fileInput (change)="onFileSelected($event)" />
        </div>

        <div *ngIf="imagePreview" class="rounded border border-gray-300 p-2">
          <img src="{{ imagePreview }}" alt="Preview" class="max-w-[200px] max-h-[150px] object-contain" />
        </div>
      </div>

      <div class="form-actions" style="float: right">
        <button (click)="addOrg('Emp')" *ngIf="!orgForm.value.additional_branch" mat-raised-button color="primary"
          matStepperNext>
          {{ "ADD_EMPLOYEE" | translate }}
        </button>
        <button *ngIf="orgForm.value.additional_branch" mat-raised-button color="primary" matStepperNext
          (click)="addOrg('Brnch')">
          {{ "ADD_BRANCH" | translate }}
        </button>
      </div>
    </form>
  </mat-step>
  <mat-step branchForm [stepControl]="branchForm" *ngIf="isBranch">
    <form [formGroup]="branchForm">
      <ng-template matStepLabel>{{ "branch.title" | translate }}</ng-template>
      <div formArrayName="additionalBranch">
        <div *ngFor="let branch of additionalBranch.controls; let i = index" [formGroupName]="i">
          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ "ORG_NAME" | translate }}</mat-label>

              <mat-form-field appearance="outline" class="half-width">
                <input matInput [value]="orgname" readonly />
              </mat-form-field>
            </div>
            <div class="half-width" *ngIf="organizationId">
              <mat-label>{{ "companyCode" | translate }}</mat-label>

              <mat-form-field appearance="outline" class="half-width">
                <input matInput [value]="orgCode" readonly />
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>{{ "org_type_" | translate }}</mat-label>

              <mat-form-field appearance="outline" class="half-width">
                <input matInput [value]="getOrgTypeLabel(orgType)" readonly />
              </mat-form-field>
            </div>
          </div>
          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ "NAME" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="primary_contact_name" required />
                <mat-error *ngIf="
                    branch.get('primary_contact_name')?.hasError('required')
                  ">
                  {{ "NAME_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>{{ "EMAIL" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="primary_contact_email" required />
                <mat-error *ngIf="
                    branch.get('primary_contact_email')?.hasError('required')
                  ">
                  {{ "EMAIL_REQUIRED" | translate }}
                </mat-error>
                <mat-error *ngIf="branch.get('primary_contact_email')?.hasError('email')">
                  {{ "EMAIL_INVALID" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>{{ "MOBILE" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="primary_contact_phone" required />
                <mat-error *ngIf="
                    branch.get('primary_contact_phone')?.hasError('required')
                  ">
                  {{ "MOBILE_REQUIRED" | translate }}
                </mat-error>
                <mat-error *ngIf="
                    branch.get('primary_contact_phone')?.hasError('pattern')
                  ">
                  {{ "MOBILE_PATTERN" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ "BRANCH_NAME" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="branch_name" />
                <mat-error *ngIf="branch.get('branch_name')?.hasError('required')">
                  {{ "BRANCH_NAME_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>{{ "DOMAIN" | translate }}</mat-label>

              <mat-form-field appearance="outline" class="full-width">
                <mat-select formControlName="domain" [multiple]="true" required>
                  <mat-option value="Consultancy">Consultancy</mat-option>
                  <mat-option value="Commercial">Commercial</mat-option>
                  <mat-option value="Road">Road</mat-option>
                  <mat-option value="Utilities">Utilities</mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('domain')?.hasError('required')">
                  {{ "DOMAIN_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ "REG_NO" | translate }}</mat-label>

              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="registration_number" />
                <mat-error *ngIf="
                    branch.get('registration_number')?.hasError('required')
                  ">
                  {{ "CIN_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>{{ "GST_NO" | translate }}</mat-label>

              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="gst_number" />
                <mat-error *ngIf="branch.get('gst_number')?.hasError('required')">
                  {{ "GST_REQUIRED" | translate }}
                </mat-error>
                <mat-error *ngIf="branch.get('gst_number')?.hasError('pattern')">
                  {{ "GST_PATTERN_INVALID" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>{{ "PAN" | translate }}</mat-label>

              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="pan_number" />
                <mat-error *ngIf="branch.get('pan_number')?.hasError('required')">
                  {{ "PAN_REQUIRED" | translate }}
                </mat-error>
                <mat-error *ngIf="branch.get('pan_number')?.hasError('pattern')">
                  {{ "PAN_PATTERN_INVALID" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label> {{ "line1" | translate }}</mat-label>

              <mat-form-field appearance="outline">
                <input matInput formControlName="address_line_1" />
                <mat-error *ngIf="branch.get('address_line_1')?.hasError('required')">
                  {{ "employee.address" | translate }}
                  {{ "REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label> {{ "line2" | translate }}</mat-label>

              <mat-form-field appearance="outline">
                <input matInput formControlName="address_line_2" />
                <mat-error *ngIf="branch.get('address_line_2')?.hasError('required')">
                  {{ "employee.address" | translate }}
                  {{ "REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ "STATE" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <mat-select formControlName="state" (selectionChange)="onStateBChange(i)" required>
                  <mat-option value="">{{
                    "SELECT_STATE" | translate
                    }}</mat-option>
                  <mat-option *ngFor="let state of availableStates[i]" [value]="state">{{ state }}</mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('state')?.hasError('required')">
                  {{ "STATE_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>{{ "DISTRICT" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <mat-select formControlName="district" (selectionChange)="onDistrictBChange(i)" required>
                  <mat-option value="">{{ "SELECT_DISTRICT" | translate }}</mat-option>
                  <mat-option *ngFor="let d of availableDistricts[i]" [value]="d">{{ d }}</mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('district')?.hasError('required')">
                  {{ "DISTRICT_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>{{ "CITY" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <mat-select formControlName="city" required>
                  <mat-option value="">{{
                    "SELECT_CITY" | translate
                    }}</mat-option>
                  <mat-option *ngFor="let city of availableCities[i]" [value]="city">{{ city }}</mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('city')?.hasError('required')">
                  {{ "CITY_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>{{ "employee.postal_code" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="postal_code" />
                <mat-error *ngIf="branch.get('postal_code')?.hasError('required')">
                  {{ "PINCODE_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <button mat-stroked-button type="button" (click)="openPicker(i, branch)">
            {{ "locateOnMap" | translate }}
          </button>
          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ "LAT" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="lat" />
                <mat-error *ngIf="branch.get('lat')?.hasError('required')">
                  {{ "LAT_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>{{ "LONG" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="long" />
                <mat-error *ngIf="branch.get('long')?.hasError('required')">
                  {{ "LONG_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="form-actions flex gap-4">
            <button mat-raised-button color="warn" *ngIf="additionalBranch.length > 1" (click)="removeBranch(i)"
              [disabled]="additionalBranch.length === 1">
              {{ "REMOVE" | translate }}
            </button>
            <button mat-raised-button color="primary" type="button" (click)="addBranch()">
              {{ "ADD_BRANCH" | translate }}
            </button>
          </div>
        </div>
      </div>
    </form>

    <div class="form-actions flex gap-4" style="float: right">
      <button mat-button matStepperPrevious style="margin-right: 5px">
        {{ "BACK" | translate }}
      </button>

      <button mat-raised-button color="primary" matStepperNext [disabled]="branchForm.invalid"
        (click)="addBranchSubmit()">
        {{ "ADD_EMPLOYEE" | translate }}
      </button>
    </div>
  </mat-step>

  <mat-step empORGForm [stepControl]="empORGForm">
    <form [formGroup]="empORGForm">
      <ng-template matStepLabel>{{ "EMPLOYEE" | translate }}</ng-template>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "ORG_NAME" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput [value]="orgname" readonly />
          </mat-form-field>
        </div>
        <div class="half-width" *ngIf="organizationId">
          <mat-label>{{ "companyCode" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput [value]="orgCode" readonly />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>{{ "org_type_" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput [value]="getOrgTypeLabel(orgType)" readonly />
          </mat-form-field>
        </div>
      </div>

      <div class="user-group grid grid-cols-12 border-t-2 pt-4 px-6 gap-8">
        <div class="col-span-4" *ngIf="branchShow">
          <mat-label>{{ "employee.branch" | translate }}
            <span class="red">*</span></mat-label>
          <mat-form-field appearance="outline">
            <mat-select formControlName="branch_id">
              <mat-option value="">{{
                "employee.select_branch" | translate
                }}</mat-option>
              <mat-option *ngFor="let branch of branchList" [value]="branch.branch_id">{{ branch.branch_name
                }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-span-4">
          <mat-label>{{ "employee.full_name" | translate }}<span class="red">*</span></mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="full_name" />
          </mat-form-field>
        </div>
        <div class="col-span-4">
          <mat-label>{{ "employee.contact_email" | translate }}<span class="red">*</span></mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="contact_email" />
          </mat-form-field>
        </div>

        <div class="col-span-4">
          <mat-label> {{ "employee.contact_phone" | translate }}<span class="red">*</span></mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="contact_phone" />
          </mat-form-field>
        </div>
        <div class="col-span-4">
          <mat-label> {{ "employeeId" | translate }}(Company)</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="employeeId" />
          </mat-form-field>
        </div>
        <div class="col-span-4">
          <mat-label>{{
            "employee.employment_start_date" | translate
            }}<span class="red">*</span></mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input matInput [matDatepicker]="startPicker" formControlName="employmentStartDate" />
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-span-4">
          <mat-label> {{ "employee.department" | translate }}<span class="red">*</span></mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="department" />
          </mat-form-field>
        </div>

        <div class="col-span-4">
          <mat-label>{{ "employee.designation" | translate }}<span class="red">*</span></mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="designation" />
          </mat-form-field>
        </div>

        <div class="col-span-4">
          <mat-label>{{ "org_type" | translate }}<span class="red">*</span></mat-label>

          <mat-form-field class="w-full" appearance="outline">
            <mat-select formControlName="roleId" (selectionChange)="onRoleChange($event.value)" required>
              <mat-option value="">Select {{ "org_type" | translate }}</mat-option>
              <mat-option *ngFor="let role of organizations" [value]="role.id">{{ role.value }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-span-4">
          <mat-label> {{ "employee.role_in_software" | translate }}<span class="red">*</span></mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <mat-select formControlName="roleInSoftware">
              <mat-option value="">Select
                {{ "employee.role_in_software" | translate }}</mat-option>
              <mat-option *ngFor="let role of designationList" [value]="role">{{
                role
                }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>


        <div class="col-span-4">
          <mat-label>{{ "employeeId" | translate }}(Software)<span class="red">*</span></mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="employeeNumber" />
          </mat-form-field>
        </div>

        <div class="col-span-4">
          <mat-label>{{
            "employee.membership_start_date" | translate
            }}<span class="red">*</span></mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input matInput [matDatepicker]="memStartPicker" formControlName="membershipStartDate" />
            <mat-datepicker-toggle matSuffix [for]="memStartPicker"></mat-datepicker-toggle>
            <mat-datepicker #memStartPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-span-4">
          <mat-label>{{
            "employee.membership_end_date" | translate
            }}<span class="red">*</span></mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input matInput [matDatepicker]="memEndPicker" formControlName="membershipEndDate" />
            <mat-datepicker-toggle matSuffix [for]="memEndPicker"></mat-datepicker-toggle>
            <mat-datepicker #memEndPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-span-4">
          <mat-label> {{ "employee.state" | translate }}<span class="red">*</span></mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <mat-select formControlName="state" (selectionChange)="onEmpStateChange()" required>
              <mat-option value="">Select State</mat-option>

              <mat-option *ngFor="let state of states" [value]="state">{{
                state
                }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-span-4">
          <mat-label> {{ "DISTRICT" | translate }}<span class="red">*</span></mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <mat-select formControlName="district" (selectionChange)="onEmpDistrictChange()" required>
              <mat-option value="">{{ "SELECT_DISTRICT" | translate }}</mat-option>
              <mat-option *ngFor="let d of empDistricts" [value]="d">{{ d }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-span-4">
          <mat-label> {{ "employee.city" | translate }}<span class="red">*</span></mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <mat-select formControlName="city" required>
              <mat-option value="">Select City</mat-option>
              <mat-option *ngFor="let city of empCities" [value]="city">{{
                city
                }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-span-4">
          <mat-label>{{ "employee.address" | translate }}<span class="red">*</span></mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="address" />
          </mat-form-field>
        </div>
        <div class="col-span-4">
          <mat-label> {{ "employee.postal_code" | translate }}<span class="red">*</span></mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="postalCode" />
          </mat-form-field>
        </div>

        <div formGroupName="emergencyContact" class="col-span-12">
          <div class="col-span-12">
            <legend>{{ "employee.emergency_contact" | translate }}</legend>
          </div>
          <div class="user-group grid grid-cols-12 border-t-2 pt-4 px-6 gap-8">
            <div class="col-span-4">
              <mat-label>{{ "employee.ec_name" | translate }}<span class="red">*</span></mat-label>

              <mat-form-field appearance="outline" class="w-full">
                <input matInput formControlName="name" />
              </mat-form-field>
            </div>

            <div class="col-span-4">
              <mat-label>{{ "employee.ec_mobile" | translate }}<span class="red">*</span></mat-label>

              <mat-form-field appearance="outline" class="w-full">
                <input matInput formControlName="mobile" />
              </mat-form-field>
            </div>
            <div class="col-span-4">
              <mat-label>{{ "employee.ec_email" | translate }}<span class="red">*</span></mat-label>

              <mat-form-field appearance="outline" class="w-full">
                <input matInput formControlName="email" />
              </mat-form-field>
            </div>
          </div>
        </div>
          <div class="form-actions" >
      
      <app-primary-button (click)="addEmp()"  [disabled]="!empORGForm.valid" color="primary" matStepperNext>
        {{ "ADD_EMPLOYEE" | translate }}
      </app-primary-button>
    </div>
      </div>

    </form>

    <div class="form-actions" style="float: right">
      <button mat-button matStepperPrevious style="margin-right: 5px">
        {{ "BACK" | translate }}
      </button>
      <button (click)="addEmp()" mat-raised-button [disabled]="!empORGForm.valid" color="primary" matStepperNext>
        {{ "ADD_EMPLOYEE" | translate }}
      </button>
    </div>
  </mat-step>

  <mat-step importFrom [stepControl]="importFrom" *ngIf="roleName == ''">
    <form [formGroup]="importFrom">
      <ng-template matStepLabel>{{ "IMPORT" | translate }}</ng-template>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "ORG_NAME" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput [value]="orgname" readonly />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>{{ "employee.branch" | translate }}
            <span class="red">*</span></mat-label>
          <mat-form-field appearance="outline">
            <mat-select formControlName="branchId">
              <mat-option value="">{{
                "employee.select_branch" | translate
                }}</mat-option>
              <mat-option *ngFor="let branch of branchList" [value]="branch.branch_id">{{ branch.branch_name
                }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Role</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <mat-select formControlName="improle">
              <mat-option *ngFor="let type of impTypes" [value]="type">{{
                type
                }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4" *ngIf="importFrom.value.improle != ''">
        <div class="toolbar">
          <input type="file" (change)="onFileChange($event)" accept=".xlsx, .xls" />
          <app-primary-button *ngIf="rowData.length != 0" (click)="saveChanges()"
            style="color: #1338de">Save</app-primary-button>
        </div>
      </div>
      <div class="grid-wrapper" *ngIf="rowData.length != 0">
        <ag-grid-angular class="ag-theme-alpine custom-grid" style="width: 100%; height: 500px" [rowData]="rowData"
          [columnDefs]="columnDefs" [defaultColDef]="defaultColDef"></ag-grid-angular>
      </div>
    </form>
  </mat-step>

  <mat-step adminForm [stepControl]="adminForm" *ngIf="roleName == 'Admin'">
    <form [formGroup]="adminForm" class="w-full">
      <ng-template matStepLabel>{{ "BASIC" | translate }}</ng-template>

      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "MEMBERSHIP_START_DATE" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput [matDatepicker]="startPicker" formControlName="membership_start_date" />
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
            <mat-error *ngIf="
                adminForm.get('membership_start_date')?.hasError('required')
              ">
              {{ "START_DATE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="half-width">
          <mat-label>{{ "MEMBERSHIP_END_DATE" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput [matDatepicker]="endPicker" formControlName="membership_end_date" />
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
            <mat-error *ngIf="adminForm.get('membership_end_date')?.hasError('required')">
              {{ "END_DATE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "ONBOARDING_DATE" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput [matDatepicker]="picker" formControlName="onboarding_date" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="adminForm.get('onboarding_date')?.hasError('required')">
              {{ "ONBOARDING_DATE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="half-width">
          <mat-label>{{ "STATUS" | translate }}</mat-label><br />
          <mat-slide-toggle formControlName="status" color="primary">
            {{
            adminForm.get("status")?.value
            ? ("ACTIVE" | translate)
            : ("INACTIVE" | translate)
            }}
          </mat-slide-toggle>
        </div>
      </div>

      <div class="form-actions">
        <button mat-button matStepperPrevious style="margin-right: 5px">
          {{ "BACK" | translate }}
        </button>
        <button mat-raised-button color="primary" matStepperNext [disabled]="!adminForm.valid">
          {{ "SUBMIT" | translate }}
        </button>
      </div>
    </form>
  </mat-step>
</mat-horizontal-stepper>